import { render, staticRenderFns } from "./right_structure_custom.vue?vue&type=template&id=ba93d390&scoped=true"
import script from "./right_structure_custom.vue?vue&type=script&lang=js"
export * from "./right_structure_custom.vue?vue&type=script&lang=js"
import style0 from "./right_structure_custom.vue?vue&type=style&index=0&id=ba93d390&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba93d390",
  null
  
)

export default component.exports